export default __webpack_public_path__ + "static/media/forMediumBlog.3add1eea.PNG";